/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, catchError, mergeMap, concatMap } from 'rxjs/operators';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { DataService } from 'app/static-data/services/data.service';
import {
  LoadStaticDataValues,
  LOAD_STATIC_DATA_VALUES,
  LoadStaticDataValuesSuccess,
  LoadStaticDataValuesError,
  LoadAllStaticDataValues,
  LOAD_ALL_STATIC_DATA_VALUES
} from './static-data.actions';

/** Effects for the details screen. */
@Injectable()
export class StaticDataEffects {
  /** Loads all static data values. */

  loadAllStaticDataValues: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<LoadAllStaticDataValues>(LOAD_ALL_STATIC_DATA_VALUES),
      mergeMap(() => [
        new LoadStaticDataValues('ccp'),
        new LoadStaticDataValues('configType'),
        new LoadStaticDataValues('currency'),
        new LoadStaticDataValues('customReportType'),
        new LoadStaticDataValues('fileFormat'),
        new LoadStaticDataValues('fileType'),
        new LoadStaticDataValues('filter'),
        new LoadStaticDataValues('emailType'),
        new LoadStaticDataValues('outputConverterType'),
        new LoadStaticDataValues('outputGrouping'),
        new LoadStaticDataValues('portfolioMarginModel'),
        new LoadStaticDataValues('reportingCalcMeasure'),
        new LoadStaticDataValues('reportingCurrency'),
        new LoadStaticDataValues('reportPostProcessorType')
      ])
    )
  );

  /** Load static data values. */

  loadStaticDataValues: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<LoadStaticDataValues>(LOAD_STATIC_DATA_VALUES),
      concatMap(action =>
        this.dataService.loadEnumerationValues(action.enumType).pipe(
          map(values => new LoadStaticDataValuesSuccess(action.enumType, values)),
          catchError(err => observableOf(new LoadStaticDataValuesError(action.enumType, err)))
        )
      )
    )
  );

  constructor(private actions: Actions, private dataService: DataService) {}
}
